<ion-row class="order-page-toolbar">
	<ion-icon
		(click)="onBackClick()"
		[class.ion-hide]="hideElements"
		class="pointer"
		size="large"
		src="../../../assets/topgolf/back.svg"
	></ion-icon>
	<ion-col class="ion-no-padding">
		<ion-row class="title-block">
			<h2 class="title">{{ title }}</h2>
		</ion-row>
	</ion-col>
	<app-burger-btn [class.ion-hide]="hideElements"></app-burger-btn>
	<!-- <ion-buttons class="close" (click)="onClose()">
        <ion-icon size="large" name="close"></ion-icon>
    </ion-buttons> -->
</ion-row>
